<template>
  <div>
    <v-layout justify-center>
      <v-dialog v-model="dialog" persistent max-width="600" content-class="bra-20">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            size="15"
            @click="abriuDialog"
          >
            mdi-pencil
          </v-icon>
        </template>

        <v-card>
          <v-card-title primary-title class="pl-6 py-3">
            <span>Influenciar projeção</span>
            <v-spacer />
            <v-btn icon @click="fechar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider />

          <v-card-text class="pt-5">
            <div>
              <v-radio-group
                v-model.number="radioSelecionado"
                class="ml-n2"
                @change="criarData"
              >
                <v-radio :value="7" class="mb-3">
                  <template #label>
                    <span class="pl-1">Uma Semana</span>
                  </template>
                </v-radio>

                <v-radio :value="30">
                  <template #label>
                    <span class="pl-1">Um Mês</span>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-menu
                ref="datepickerMenu"
                v-model="datepickerMenu"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fatorAtuacao.data"
                    outlined
                    v-mask="maskData"
                    persistent-hint
                    v-bind="attrs"
                    messages="Data de vencimento do fator de atuação"
                    class="mb-3"
                    v-on="on"
                    :error-messages="errorDataLimite"
                    @input="$v.fatorAtuacao.data.$touch()"
                    @blur="$v.fatorAtuacao.data.$touch()"
                  />
                </template>

                <v-date-picker
                  v-model="datepicker"
                  no-title
                  @input="onPickDate"
                />
              </v-menu>
            </div>
            <v-layout>
              <v-flex xs12>
                <v-select
                  outlined
                  v-model="fatorAtuacao.produtoOuFornecedor"
                  :items="selects.produtoOuFornecedor"
                  label="Selecione um Produto"
                  item-value="id"
                  item-text="descricao"
                  :error-messages="errorProdutoOuFornecedor"
                  @input="$v.fatorAtuacao.produtoOuFornecedor.$touch()"
                  @blur="$v.fatorAtuacao.produtoOuFornecedor.$touch()"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-select
                  outlined
                  v-model="fatorAtuacao.tipoAjuste"
                  :items="selects.tipoAjuste"
                  label="Selecione o Tipo de Ajuste*"
                  item-value="id"
                  item-text="tipo"
                  :error-messages="errorTipoAjuste"
                  @input="$v.fatorAtuacao.tipoAjuste.$touch()"
                  @blur="$v.fatorAtuacao.tipoAjuste.$touch()"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  class="ml-5"
                  outlined
                  v-model="fatorAtuacao.qtdeAjuste"
                  label="Informe o Percentual*"
                  placeholder="Ex: 50"
                  suffix="%"
                  :error-messages="errorQtdeAjuste"
                  @input="$v.fatorAtuacao.qtdeAjuste.$touch()"
                  @blur="$v.fatorAtuacao.qtdeAjuste.$touch()"
                  @focus="ev => ev.target.select()"
                  @keyup.enter="salvar"
                />
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-actions style="margin-top: -10px">
            <v-spacer />
            <v-btn color="primary" text @click="salvar">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import CompraAPI from "./../../../api/compra";
import moment from "moment";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  data: () => ({
    dialog: false,
    radioSelecionado: null,
    fatorAtuacao: {
      data: "",
      produtoOuFornecedor: 1,
      tipoAjuste: "",
      qtdeAjuste: "",
    },
    selects: {
      produtoOuFornecedor: [
        { id: 1, descricao: "SOMENTE ITEM CORRENTE" },
        { id: 2, descricao: "TODOS OS ITENS DO FORNECEDOR" },
      ],
      tipoAjuste: [
        { id: 1, tipo: "Aumento" },
        { id: 2, tipo: "Redução" },
      ],
    },
    datepickerMenu: false,
    datepicker: "",
    maskData: "##/##/####",
  }),
  validations: {
    fatorAtuacao: {
      data: {
        required,
        posteriorHoje() {
          const m = moment(this.fatorAtuacao.data, "DD/MM/YYYY", true);
          return m.isValid() && m.isAfter(moment(), "day");
        },
      },
      produtoOuFornecedor: { required },
      tipoAjuste: { required },
      qtdeAjuste: {
        required,
        ajusteValido() {
          if (Number(this.fatorAtuacao.tipoAjuste) === 2 && Number(this.fatorAtuacao.qtdeAjuste) >= 100) {
            return false;
          }
          return true;
        },
      },
    },
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      detalhesProduto: "detalhe_produto/getProduto",
      FORNECEDOR_COMPRA: "fornecedor/getFornecedor",
    }),
    errorDataLimite() {
      const errors = [];
      if (!this.$v.fatorAtuacao.data.$dirty) return errors;
      !this.$v.fatorAtuacao.data.required && errors.push("Campo Obrigatório.");
      !this.$v.fatorAtuacao.data.posteriorHoje && errors.push("Data limite deve ser posterior a hoje.");
      return errors;
    },
    errorProdutoOuFornecedor() {
      const errors = [];
      if (!this.$v.fatorAtuacao.produtoOuFornecedor.$dirty) return errors;
      !this.$v.fatorAtuacao.produtoOuFornecedor.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    errorTipoAjuste() {
      const errors = [];
      if (!this.$v.fatorAtuacao.tipoAjuste.$dirty) return errors;
      !this.$v.fatorAtuacao.tipoAjuste.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    errorQtdeAjuste() {
      const errors = [];
      if (!this.$v.fatorAtuacao.qtdeAjuste.$dirty) return errors;
      !this.$v.fatorAtuacao.qtdeAjuste.required && errors.push("Campo Obrigatório.");
      !this.$v.fatorAtuacao.qtdeAjuste.ajusteValido && errors.push("Redução máxima é de 99%.");
      return errors;
    },
  },
  methods: {
    criarData(qtdeDias) {
      if (!qtdeDias) return;

      this.fatorAtuacao.data = moment()
        .add(Number(qtdeDias), "days")
        .format("DD/MM/YYYY");

      this.datepicker = moment(this.fatorAtuacao.data, "DD/MM/YYYY", true).format("YYYY-MM-DD");
    },
    onPickDate(value) {
      this.datepicker = value;
      this.fatorAtuacao.data = moment(value, "YYYY-MM-DD", true).format("DD/MM/YYYY");
      this.radioSelecionado = null;
      this.$v.fatorAtuacao.data.$touch();
    },
    salvar() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const headers = this.Helpers.iniciarRequisicao();

      const data_limite = moment(this.fatorAtuacao.data, "DD/MM/YYYY", true).format("YYYY-MM-DD");

      const params = {
        id_fa: this.detalhesProduto.id_fator_atuacao,
        fornOuProd: this.fatorAtuacao.produtoOuFornecedor,
        idproduto: this.detalhesProduto.idproduto,
        produtos: this.detalhesProduto.produtos,
        idfornecedor: this.FORNECEDOR_COMPRA.id,
        grupo: this.detalhesProduto.id_grupo,
        tipoAjuste: this.fatorAtuacao.tipoAjuste,
        qtdeAjuste: this.fatorAtuacao.qtdeAjuste,
        data_limite: data_limite,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.setFatorAtuacao(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            const timestamp = new Date().getTime();
            this.fechar();
            this.$emit("atualizar-produtos", timestamp);
            this.$emit("ocultar-detalhes-produto");
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    abriuDialog() {
      this.dialog = true;

      const { percentual, fator_atuacao, data_limite_fa } = this.detalhesProduto;

      if (percentual > 0) {
        this.fatorAtuacao.qtdeAjuste = percentual;
        this.fatorAtuacao.tipoAjuste = parseInt(fator_atuacao, 10) >= 1 ? 1 : 2;

        if (data_limite_fa) {
          const m = moment(data_limite_fa, ["YYYY-MM-DD", "DD/MM/YYYY"], true);
          this.fatorAtuacao.data = m.isValid() ? m.format("DD/MM/YYYY") : "";
          this.datepicker = m.isValid() ? m.format("YYYY-MM-DD") : "";
        } else {
          this.fatorAtuacao.data = "";
          this.datepicker = "";
        }
      }
    },
    fechar() {
      this.$v.$reset();
      this.dialog = false;
      this.fatorAtuacao.qtdeAjuste = "";
      this.fatorAtuacao.tipoAjuste = "";
      this.fatorAtuacao.data = "";
      this.datepicker = "";
      this.radioSelecionado = null;
    },
  },
};
</script>
